import React, { Component } from "react";
import ReportModal from "../../../base/features/blocks/ReportModal";
import Spinner from "../../../base/features/micro/Spinner";
import Image from "../../../base/features/micro/Image";
import DynamicView from "../../dynamicView/DynamicView";
import OtherShops from "../blocks/OtherShops";
import ShopContacts from "../blocks/ShopContacts";
import ShopCoordinates from "../blocks/ShopCoordinates";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import Carousel from "react-multi-carousel";
import checkLength from "../../../base/utils/check_length";
import createLink from "../../../base/utils/createLink";
import OpenApp from "react-open-app";
import { isSiteDomain } from "../../../settings/domainManager";

class ShopHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptReportModal: false,
      openDes: [],
    };
  }

  get verifyText() {
    if (
      this.props.shopProperties.personalize &&
      this.props.shopProperties.personalize.verify_text
    )
      return this.props.shopProperties.personalize.verify_text;
    return "احراز هویت شده توسط گیتی مارکت";
  }

  get showVerify() {
    return this.props.shopProperties.is_verify && !isSiteDomain;
  }

  get showSubTitle() {
    return !isSiteDomain;
  }

  render() {
    return (
      <div>
        {this.props.shopProperties ? (
          <section>
            {this.state.acceptReportModal && (
              <ReportModal
                uId={this.props.shopProperties.uid}
                acceptReportModal={this.state.acceptReportModal}
                modalChange={(value) =>
                  this.setState({ acceptReportModal: value })
                }
                type={"shop"}
              />
            )}
            <body style={{ zIndex: "-2" }}>
              <div
                className="row mx-0 px-0"
                style={{ marginTop: "72px" }}
                dir="rtl"
              >
                <div className="row mx-0 px-4 mb-4">
                  <div className="col-auto px-0">
                    <Image
                      imageUri={
                        this.props.shopProperties &&
                        this.props.shopProperties.cover &&
                        this.props.shopProperties.cover.file
                      }
                      imgClassName={"img-cover rounded14"}
                      imageHeight={"80"}
                      imageWidth={"80"}
                      extraClassName={"rounded-circle bg-color-main p-2"}
                    />
                  </div>
                  <div className="col px-0 pe-2">
                    <h1 className="fs-3 fw-bolder mb-0">
                      {this.props.shopProperties.title}
                    </h1>
                    {this.showSubTitle && (
                      <p className="fs-6 text-muted fw-bold mb-1">
                        {this.props.shopProperties.sub_title}
                      </p>
                    )}
                    {this.props.shopProperties.categories.length > 0 &&
                      this.props.shopProperties.categories.map(
                        (category, c) => (
                          // <Link
                          //   to={`/search?categoryUid=${category.uid}&categoryTitle=${category.title}`}
                          // >
                          <span
                            className="ps-2 d-inline-block fs-7 color-main"
                            key={c}
                          >
                            {category.title}
                          </span>
                          // </Link>
                        )
                      )}
                  </div>
                </div>
                {this.showVerify && (
                  <div className="row mx-0 px-4 mb-4">
                    <div className="row mx-0 rounded14 bg-light-green px-4 py-3">
                      <div className="col-auto align-self-center px-0">
                        <img
                          alt="verify"
                          src={
                            require("../../../base/assets/icons/verify.svg")
                              .default
                          }
                        />
                      </div>
                      <div className="col px-2 align-self-center">
                        <p className="color-main mb-0 fw-bold fs-6">
                          {this.verifyText}
                        </p>
                      </div>
                      {/* <div className="col-auto align-self-center px-0 color-main">
                        <FiChevronLeft size="22" />
                      </div> */}
                    </div>
                  </div>
                )}
                {this.props.shopProperties.views &&
                  this.props.shopProperties.views.header && (
                    <DynamicView
                      viewPage="shopHome"
                      view={this.props.shopProperties.views.header}
                    />
                  )}
                {this.props.shopProperties.quick_contacts &&
                this.props.shopProperties.quick_contacts.length > 0 ? (
                  <div className="row mx-0 px-4 py-1">
                    {this.props.shopProperties.quick_contacts.map(
                      (contact, c) => (
                        <div className="col px-1">
                          <OpenApp
                            href={createLink(contact)}
                            android={createLink(contact, "android")}
                            ios={createLink(contact)}
                          >
                            <button className="btn w-100 py-2 fw-bold small border color-main rounded28">
                              <Image
                                imageUri={
                                  contact.type.icon &&
                                  contact.type.icon.icon_128
                                }
                                imgClassName={"img-cover ms-2"}
                                imageHeight={"20"}
                                imageWidth={"20"}
                                extraClassName={
                                  "rounded-circle bg-color-main p-1"
                                }
                              />
                              {contact.type.title}
                            </button>
                          </OpenApp>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
                {this.props.shopProperties.infos &&
                this.props.shopProperties.infos.length ? (
                  <div className="row mx-0 px-4 py-3">
                    <div
                      style={{
                        overflow: "scroll hidden",
                        whiteSpace: "nowrap",
                      }}
                      className="px-0 py-3 col-12 scrollbar-hide"
                    >
                      {this.props.shopProperties.infos.map((info, i) => (
                        <div className="d-inline-block px-3 border-start">
                          <p className="fw-bold small text-secondary mb-1">
                            {info.title}
                          </p>
                          <p className="fw-bold mb-0 text-end" dir="ltr">
                            {info.value}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {this.props.shopProperties.views &&
                  this.props.shopProperties.views.under_info && (
                    <DynamicView
                      viewPage="shopHome"
                      view={this.props.shopProperties.views.under_info}
                    />
                  )}

                <div className="row mx-0 px-4 py-3 border-bottom">
                  {this.props.shopProperties.des && (
                    <div className="col-12 px-0">
                      <p className="mb-2 fs-5 fw-bold">درباره</p>
                      <p
                        className="small text-secondary"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {!this.state.fullDes &&
                          checkLength(this.props.shopProperties.des, 100, true)}
                        {this.state.fullDes && this.props.shopProperties.des}
                        {this.props.shopProperties.des.length > 100 && (
                          <p
                            className="color-main fw-bold mb-0 fs-6 mt-2"
                            onClick={() =>
                              this.setState({ fullDes: !this.state.fullDes })
                            }
                          >
                            {this.state.fullDes ? (
                              <span>
                                کمتر
                                <FiChevronUp className="me-1" size="18" />
                              </span>
                            ) : (
                              <span>
                                بیشتر
                                <FiChevronDown className="me-1" size="18" />
                              </span>
                            )}
                          </p>
                        )}
                      </p>
                    </div>
                  )}
                </div>

                {this.props.shopProperties.views &&
                  this.props.shopProperties.views.under_des && (
                    <DynamicView
                      viewPage="shopHome"
                      view={this.props.shopProperties.views.under_des}
                    />
                  )}

                <div className="row mx-0 px-4 py-3 border-bottom">
                  {this.props.shopProperties.extras &&
                    this.props.shopProperties.extras.map((extra, e) => (
                      <div className="col-12 px-0">
                        <p className="mb-2 fs-5 fw-bold">{extra.title}</p>
                        <p
                          className="small text-secondary"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {!this.state.openDes.includes(extra) &&
                            checkLength(extra.des, 100, true)}
                          {this.state.openDes.includes(extra) && extra.des}
                          {extra.des.length > 100 && (
                            <p
                              className="color-main fw-bold mb-0 fs-6 mt-2"
                              onClick={() => {
                                if (this.state.openDes.includes(extra)) {
                                  this.setState({
                                    openDes: this.state.openDes.filter(
                                      (item) => item !== extra
                                    ),
                                  });
                                } else {
                                  var old_des = this.state.openDes;
                                  old_des.push(extra);
                                  this.setState({ openDes: old_des });
                                }
                              }}
                            >
                              {this.state.openDes.includes(extra) ? (
                                <span>
                                  کمتر
                                  <FiChevronUp className="me-1" size="18" />
                                </span>
                              ) : (
                                <span>
                                  بیشتر
                                  <FiChevronDown className="me-1" size="18" />
                                </span>
                              )}
                            </p>
                          )}
                        </p>
                      </div>
                    ))}
                </div>

                {this.props.shopProperties.views &&
                  this.props.shopProperties.views.under_extras && (
                    <DynamicView
                      viewPage="shopHome"
                      view={this.props.shopProperties.views.under_extras}
                    />
                  )}

                {this.props.shopProperties.trust_comments &&
                  this.props.shopProperties.trust_comments.length > 0 && (
                    <div className="row mx-0 px-4 py-3 mb-4 border-bottom">
                      <div className="col-12 px-0 mb-2">
                        <h2 className="fw-bold fs-5 mb-0">نظرات مشتریان</h2>
                      </div>
                      <div className="col-12 px-0" dir="ltr">
                        <Carousel
                          className="mb-0"
                          autoPlay={false}
                          responsive={{
                            all: {
                              breakpoint: { max: 4000, min: 0 },
                              items: 1,
                            },
                          }}
                          focusOnSelect={true}
                          showDots={true}
                          infinite={true}
                          draggable={true}
                          swipeable={true}
                          keyBoardControl={true}
                          arrows={false}
                          sliderClass="h-100 mb-4"
                          containerClass="carousel-container"
                          dotListClass="custom-dot-list-style"
                        >
                          {this.props.shopProperties.trust_comments.map(
                            (comment, c) => (
                              <div className="col-12 text-center px-0">
                                <Image
                                  imageUri={
                                    comment.user &&
                                    comment.user.image &&
                                    comment.user.image
                                  }
                                  isProfile={true}
                                  imgClassName={"img-cover rounded-circle"}
                                  imageHeight={"40"}
                                  imageWidth={"40"}
                                  extraClassName={"p-0"}
                                />
                                <p className="fw-bold fs-6 my-2">
                                  {comment.user.name}
                                </p>
                                <p className="small text-secondary mb-1">
                                  {comment.comment}
                                </p>
                              </div>
                            )
                          )}
                        </Carousel>
                      </div>
                    </div>
                  )}

                {this.props.shopProperties.views &&
                  this.props.shopProperties.views.under_trust_comments && (
                    <DynamicView
                      viewPage="shopHome"
                      view={
                        this.props.shopProperties.views.under_trust_comments
                      }
                    />
                  )}
              </div>
              {this.props.shopProperties.contacts &&
                this.props.shopProperties.contacts.length > 0 && (
                  <section className="px-4 mt-3">
                    <div className="col-12 px-0 mb-2">
                      <h2 className="fw-bold fs-5 mb-0">اطلاعات تماس</h2>
                    </div>
                    {this.props.shopProperties.contacts.map((contact, c) => (
                      <ShopContacts contact={contact} key={c} />
                    ))}
                  </section>
                )}
              {this.props.shopProperties.coordinates && (
                <ShopCoordinates
                  coordinates={this.props.shopProperties.coordinates}
                />
              )}
              {/* {this.props.shopProperties.facilities &&
                this.props.shopProperties.facilities.length > 0 && (
                  <ShopFacilities
                    facilities={this.props.shopProperties.facilities}
                  />
                )} */}

              {this.props.shopProperties.views &&
                this.props.shopProperties.views.under_contacts && (
                  <DynamicView
                    viewPage="shopHome"
                    view={this.props.shopProperties.views.under_contacts}
                  />
                )}

              {this.props.shopProperties.other_shops &&
                this.props.shopProperties.other_shops.length > 0 && (
                  <OtherShops shops={this.props.shopProperties.other_shops} />
                )}

              {this.props.shopProperties.views &&
                this.props.shopProperties.views.footer && (
                  <DynamicView
                    viewPage="shopHome"
                    view={this.props.shopProperties.views.footer}
                  />
                )}
              <div className="pt-2 pb-4 text-center">
                <button
                  className="btn py-2 px-4 fs-6 fw-bold text-danger text-center border rounded28"
                  onClick={() => this.setState({ acceptReportModal: true })}
                >
                  گزارش تخلف فروشگاه
                </button>
              </div>

              <div className="col-12 text-center pb-5 text-muted small">
                ساخته شده با گیتی مارکت
              </div>
            </body>
          </section>
        ) : (
          <div style={{ marginTop: "100px", zIndex: "-2" }}>
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default ShopHome;
